import React from "react";
import logo from "../images/logo.png";
import { Link, NavLink } from "react-router-dom";
import defaultuser from "../managment/images/defaultuser.png";

class Navbar extends React.Component {
  render() {
    let user = null;
    if (localStorage.getItem("token")) {
      user = JSON.parse(localStorage.getItem("user"));
    }

    return (
      <nav className="navbar has-shadow is-info is-fixed-top">
        <div className="navbar-brand">
          <a className="navbar-item has-text-white is-size-6" href="/">
            <img src={logo} className="mr-2" alt="" /> VehShop
          </a>
          <div
            className="navbar-burger burger"
            data-target="navbarExampleTransparentExample"
          >
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>

        <div id="navbarExampleTransparentExample" className="navbar-menu ">
          <div className="navbar-start has-text-white"></div>

          <div className="navbar-end">
            <NavLink
              activeClassName="is-active"
              to="/about/"
              className="navbar-item"
            >
              <span className="">ABOUT</span>
            </NavLink>

            <NavLink
              activeClassName="is-active"
              to="/myshop/home/"
              className="navbar-item"
            >
              <span className="">MY SHOP</span>
            </NavLink>

            <NavLink
              activeClassName="is-active"
              to="/market/"
              className="navbar-item"
            >
              <span className="">MARKET</span>
            </NavLink>

            <NavLink
              activeClassName="is-active"
              to="/support/helpdesk/"
              className="navbar-item"
            >
              <span className="">HELP DESK</span>
            </NavLink>

            <NavLink
              activeClassName="is-active"
              to="/contact/"
              className="navbar-item"
            >
              <span className="">CONTACT</span>
            </NavLink>

            <NavLink
              activeClassName="is-active"
              to="/terms/"
              className="navbar-item"
            >
              <span className="">TERMS</span>
            </NavLink>

            {!user ? (
              <div className="navbar-item">
                <Link to="/login/">
                  <span className="button is-primary">
                    <span className="zmdi zmdi-sign-in mr-2"></span>
                    Login
                  </span>
                </Link>
              </div>
            ) : (
              <div className="navbar-item has-dropdown is-hoverable">
                <div className="navbar-link">
                  <span className="mr-2">
                    <img className="profile-image" src={defaultuser} alt="" />
                  </span>
                  <span>{user.first_name}</span>
                </div>

                <div className="navbar-dropdown">
                  <div className="navbar-item">
                    <span className="zmdi zmdi-account mr-2"></span>
                    <Link to="/profile/">Profile</Link>
                  </div>

                  <hr className="navbar-divider" />

                  <div className="navbar-item static-link has-text-danger">
                    <Link to="/logout/">
                      <span className="zmdi zmdi-power-off mr-2"></span>
                      Logout
                    </Link>
                  </div>
                </div>
              </div>
            )}

            {!user ? (
              <div className="navbar-item">
                <Link to="/signup/">
                  <span className="button is-white">
                    <span className="zmdi zmdi-account-add mr-2"></span>
                    Signup
                  </span>
                </Link>
              </div>
            ) : (
              <div></div>
            )}
          </div>
        </div>
      </nav>
    );
  }
}

export default Navbar;
